import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { FlatButton, MuiThemeProvider } from 'material-ui';
import noop from '../tools/noop';
import styles from './Button.style';

export const ButtonTypes = {
  DEFAULT: 'default',
};

export const ButtonComponent = (props) => {
  const {
    className = '',
    disabled = false,
    fullWidth = false,
    iconComponent,
    onClick = noop,
    rounded = true,
    style = {},
    styleType = ButtonTypes.DEFAULT,
    text = '',
    translated = true,
    type = 'button',
    values,
  } = props;

  const buttonClass = `${className} button ${styleType}`;
  let buttonStyle;

  switch (styleType) {
  case ButtonTypes.DEFAULT:
  default:
    buttonStyle = styles.defaultButton;
    break;
  }

  if (rounded) {
    buttonStyle = {
      ...buttonStyle,
      ...styles.buttonRadius,
    };
  }

  if (fullWidth) {
    buttonStyle = {
      ...buttonStyle,
      ...styles.fullWidth,
    };
  }

  buttonStyle = { ...buttonStyle, ...style };

  if (disabled) {
    buttonStyle = {
      ...buttonStyle,
      ...buttonStyle.disabled,
    };
  }

  let label;

  if (translated) {
    label = <FormattedMessage id={text} values={values} />;
  } else {
    label = text;
  }

  return (
    <MuiThemeProvider>
      <FlatButton
        type={type}
        className={buttonClass}
        label={label}
        labelStyle={buttonStyle.labelStyle}
        onClick={onClick}
        style={buttonStyle}
        rippleColor={styles.rippleColor}
        disabled={disabled}
        icon={iconComponent}
      />
    </MuiThemeProvider>
  );
};

ButtonComponent.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  iconComponent: PropTypes.element,
  onClick: PropTypes.func,
  rounded: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  styleType: PropTypes.string,
  text: PropTypes.string,
  translated: PropTypes.bool,
  type: PropTypes.string,
  values: PropTypes.objectOf(PropTypes.string),
};

export default injectIntl(ButtonComponent);
